import BaseModal from 'components/Modals/BaseModal';
import FloodDeviceSettings from 'features/Integrations/features/ConnectedDevices/features/FloodDeviceSettings/index.web';
import { Device } from 'features/Integrations/features/ConnectedDevices/types/MonitoringStation_types';

type Props = {
  stageOpen: boolean;
  stageDevice: Device | null;
  onSetStageOpen: (v: boolean) => void;
};

export default function FloodStageModal({ stageOpen, stageDevice, onSetStageOpen }: Props) {
  return (
    <>
      <BaseModal
        show={stageOpen}
        handleShow={() => onSetStageOpen(false)}
        title={
          stageDevice
            ? `${stageDevice.static_id ? `${stageDevice.static_id} ` : ''}${stageDevice.alias} (${stageDevice.node_id})`
            : 'Device Settings'
        }
      >
        <FloodDeviceSettings />
      </BaseModal>
    </>
  );
}
